import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import DataIntegrationForm from "./dataIntegrationComponents/DataIntegrationForm";

import {
  useGetDataIntegrationDetailQuery,
  useUpdateDataIntegrationMutation,
} from "store/services/dataIntegrationApi";

import { useAppMeta } from "hooks";

const DataIntegrationEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Data Integration", path: "/app/crm/dataIntegration/list" },
    { title: "Data Integration" },
  ];

  // RTK Query
  const {
    data: dataIntegrationDetail,
    isLoading: loadingDataIntegration,
    error,
  } = useGetDataIntegrationDetailQuery(id);
  const [updateDataIntegration, { isLoading: updatingIntegration }] =
    useUpdateDataIntegrationMutation();
  // Update handler
  const handleUpdateIntegration = async (data) => {
    const payload = { id, ...data };

    try {
      await updateDataIntegration(payload).unwrap();
      toast.success("Data Integration successfully updated!");
      navigate(`/app/crm/dataIntegration/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Integration!"
      );
    }
  };

  useAppMeta("Edit Data Integration");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingDataIntegration || updatingIntegration}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <DataIntegrationForm
          isBusy={loadingDataIntegration || updatingIntegration}
          dataIntegrationDetail={dataIntegrationDetail}
          onSubmit={handleUpdateIntegration}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default DataIntegrationEditScreen;
